module.exports = __webpack_public_path__ + "media/images/eraf_sunstar_en-898f06c7ca649471970558fce62cb6ac.svg";